import React from "react";
import "../assets/css/styles.css";
import fresh_produce from "../assets/images/fresh_produce2.png";
import sustainable_farming from "../assets/images/sustainable_farming2.png";
import flexible_options from "../assets/images/flexible_options2.png";
import affordable_pricing from "../assets/images/affordable_pricing2.png";

const FEATURES = [
  {
    image: fresh_produce,
    title: "Fresh Produce",
    body: "Experience unparalleled freshness with fruits and vegetables harvested at peak ripeness.",
  },
  {
    image: sustainable_farming,
    title: "Sustainable Farming",
    body: "Support eco-friendly practices that promote biodiversity and protect the environment.",
  },
  {
    image: flexible_options,
    title: "Flexible Options",
    body: "Customize your order to suit your family's preferences and dietary needs with ease.",
  },
  {
    image: affordable_pricing,
    title: "Affordable Pricing",
    body: "Enjoy high-quality organic produce at prices that fit your budget, with value in every dollar.",
  },
];

const WhyUs = () => {
  return (
    <section id="why-us" className="section section--alt why-us">
      <div className="container">
        <div className="section-head" data-reveal>
          <span className="eyebrow">Why choose us</span>
          <h2>Food you can trace, quality you can taste</h2>
          <p>
            Four reasons families across Calgary keep coming back to their community share.
          </p>
        </div>

        <div className="feature-grid">
          {FEATURES.map((feature, index) => (
            <article
              className="feature-card"
              key={feature.title}
              data-reveal
              style={{ "--reveal-delay": `${index * 90}ms` }}
            >
              <div className="feature-media">
                <img src={feature.image} alt={feature.title} loading="lazy" />
                <span className="feature-index">{String(index + 1).padStart(2, "0")}</span>
              </div>
              <div className="feature-body">
                <h3>{feature.title}</h3>
                <p>{feature.body}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
